module.exports = __webpack_public_path__ + "static/media/cybercrime-large.f7e1e67e.png";